<template>
  <div class="max-resolution">
    <div
      class="spinner"
      id="spinner"
      v-show="spinnerOn"
    ></div>
    <div
      class="col-sm-11 custom-display-flex mt-5 mr-auto ml-auto book-demo-border-box"
    >
      <div
        class="col-sm-5 text-center mt-auto mb-auto"
        v-if="!show_general_inquiry"
      >
        <p class="contact-us-heading mobile-view-top-margin">General Inquiry</p>
        <button
          class="darkblue-btn-analytics m-3"
          @click="show_general_inquiry = !show_general_inquiry"
        >
          Contact us
        </button>
      </div>
      <div class="col-sm-7 mt-auto mb-auto" v-if="show_general_inquiry">
        <div class="text-center analytics-header mobile-view-top-margin">
          REQUEST INFO
        </div>
        <div class="text-center mt-1 mb-5">
          Drop us a line, we will get back and see how we can help.
        </div>
        <form @submit.prevent="contact_us_submit">
          <div class="custom-display-flex">
            <div class="col-sm-6">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Full Name"
                  required
                  v-model="form_info.full_name"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="exampleInputPassword1"
                  required
                  placeholder="Company"
                  v-model="form_info.company"
                />
              </div>
            </div>
          </div>
          <div class="custom-display-flex">
            <div class="col-sm-6">
              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Email Address"
                  required
                  v-model="form_info.email"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <input
                  type="number"
                  class="form-control"
                  placeholder="Phone"
                  required
                  v-model="form_info.phone"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                placeholder="Your Message"
                style="
                  resize: none;
                  padding-top: 20px;
                  border-radius: 20px !important;
                "
                v-model="form_info.message"
              ></textarea>
            </div>
          </div>
          <div class="col-sm-12 text-center">
            <button class="darkblue-btn-analytics m-3" type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
      <div class="vr"></div>
      <div class="col-sm-5 mt-auto mb-auto" id="partnership_div">
        <div class="col-sm-12 text-center" v-if="show_general_inquiry">
          <hr class="custom-features-mobile-display" />
          <p class="contact-us-heading">Partnership</p>
          <button
            class="darkblue-btn-analytics m-3"
            @click="show_general_inquiry = !show_general_inquiry"
          >
            Contact us
          </button>
        </div>
        <div class="col-sm-12" v-if="!show_general_inquiry">
          <hr class="custom-features-mobile-display" />
          <div class="text-center analytics-header" style="white-space: nowrap;">
            PARTNERSHIP REQUEST
            </div>
          <br />
          <div class="text-center mt-1 mb-5">
            Drop us a line, we will get back and see how we can work together.
          </div>
          <form @submit.prevent="contact_us_submit">
            <div class="custom-display-flex">
              <div class="col-sm-6">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="emailHelp"
                    placeholder="Full Name"
                    v-model="form_info.full_name"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Company"
                    v-model="form_info.company"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="custom-display-flex">
              <div class="col-sm-6">
                <div class="form-group">
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Email Address"
                    v-model="form_info.email"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Phone"
                    v-model="form_info.phone"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  placeholder="Your Message"
                  style="
                    resize: none;
                    padding-top: 20px;
                    border-radius: 20px !important;
                  "
                  v-model="form_info.message"
                ></textarea>
              </div>
            </div>
            <div class="col-sm-12 text-center">
              <button class="darkblue-btn-analytics m-3" type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- <trusted-by></trusted-by> -->
  </div>
</template>

<script>
// import TrustedBy from '../components/TrustedBy.vue'
import $ from "jquery";
export default {
  name: "ContactUs",
  components: {
    // "trusted-by": TrustedBy,
  },
  data() {
    return {
      show_general_inquiry: true,
      show_partnership: false,
      spinnerOn: false,
      form_info: {
        request_type: "General Inquiry",
        full_name: null,
        company: null,
        email: null,
        phone: null,
        message: null,
      },
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    show_general_inquiry(newVal, oldVal) {
      this.clear_form_values();
      // console.log(newVal);
      // console.log(oldVal);
      if (newVal === false) {
        this.form_info.request_type = "Partnership Request";
        $("#partnership_div").removeClass("col-sm-5");
        $("#partnership_div").addClass("col-sm-7");
      } else {
        this.form_info.request_type = "General Inquiry";
        $("#partnership_div").removeClass("col-sm-7");
        $("#partnership_div").addClass("col-sm-5");
      }
    },
  },
  mounted() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  },
  methods: {
    contact_us_submit() {
      this.spinnerOn = true;
      this.$CensePortalHttp
        .post("user/portal/website-contact-us", this.form_info)
        .then((response) => {
          this.spinnerOn = false;
          if (response.data.status === "Success") {
            this.clear_form_values();
            this.$swal.fire({
              icon: "success",
              text:
                "We have received your request. We'll get in touch with you!",
              showCancelButton: false,
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text:
                "There was an error in saving your request. Please try again.",
              showCancelButton: false,
            });
          }
        })
        .catch(() => {
          this.spinnerOn = false;
          this.$swal.fire({
            icon: "error",
            text:
              "There was an error in saving your request. Please try again.",
            showCancelButton: false,
          });
        });
    },
    clear_form_values() {
      this.form_info.full_name = null;
      this.form_info.email = null;
      this.form_info.company = null;
      this.form_info.phone = null;
      this.form_info.message = null;
    },
  },
};
</script>
<style scoped>
.max-resolution {
  max-width: 1440px; 
  margin: auto !important;
}
</style>